import React from "react";
import DocList from "../../_components/Sales/SalesDocList";
import {
    FiCheckCircle, FiClock, FiFileText,
    FiXCircle, FiUser, FiDollarSign, FiTag,
    FiHome
} from "react-icons/fi";
import { T, fmtMYR } from "../../_components/Sales/SalesShared";
import { getCreditNotes, getCNKpis, deleteCreditNote } from "../../_services/finance.service";


export default function CreditNotes() {
    return (
        <DocList
            docType="Credit Note"
            basePath="/finance/credit-notes"
            fetchList={getCreditNotes}
            fetchKpis={getCNKpis}
            deleteItem={deleteCreditNote}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected"]}
            kpiCards={[
                { label: "Total Credit Notes", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiHome, label: "Company Name", key: "customer" },
                { icon: FiFileText, label: "Invoice Ref.", key: "invoiceId" },
                { icon: FiTag, label: "Reason", key: "reason" },
                { icon: FiDollarSign, label: "Credit Amount", key: "grandTotal", render: (v) => fmtMYR(v) },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "CN No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person" },
                { key: "customer", label: "Company Name" },
                { key: "grandTotal", label: "Credit Amount" },
            ]}
        />
    );
}